export default "__VITE_ASSET__e9eca301__"